<div class="d-none d-sm-block d-md-block d-lg-block d-xl-block">
  <div class="row">
    <header class="header">
      <navigation-trigger class="width-navigation" [class.d-none]="isPublic"></navigation-trigger>
      <div class="header__logo">
        <h1>
          <a [href]="redirectToHomepage">
            <img src="assets/images/logo/jul-logowhite.png" />
          </a>
        </h1>
      </div>
      <div domain class="environment_mode_big" *ngIf="!production && mediaSize == 3">
        <label class="environment_label_big">{{ environmentLabel | translate }}</label>
      </div>
      <div domain class="environment_mode_regular" *ngIf="!production && mediaSize == 2">
        <label class="environment_label_regular">{{ environmentLabel | translate }}</label>
      </div>
      <div domain class="environment_mode_small" *ngIf="!production && mediaSize == 1">
        <label class="environment_label_small">{{ environmentLabel | translate }}</label>
      </div>

      <div [class.d-none]="isPublic" class="top-menu">
        <app-header-menu></app-header-menu>
      <!-- <app-header-search #search class="toggled header-search" [class.toggled]="search.searchActive"></app-header-search>-->
      </div>
      <ul [class.d-none]="isPublic" class="top-nav">
        <div [class.admin-button-div]="!isAdmin && isSuperUser" [class.fake-space]="!(!isAdmin && isSuperUser)">
          <button *ngIf="!isAdmin && isSuperUser" class="btn admin-button" (click)="loadMenuAdmin()">{{ 'administrator.button.admin' | translate }}</button>
        </div>
        <!-- <li class="d-xl-none">
          <a (click)="search.searchActive = true">
            <i class="zmdi zmdi-search"></i>
          </a>
        </li>-->
        <li>
          <app-notifications></app-notifications>
        </li>
        <li>
          <app-tasks></app-tasks>
        </li>

        <li dropdown class="user-authenticated">

          <!-- Can Impersonificate View -->

          <ng-container *ngIf="currentUser?.canImpersonificate || isImpersonalization">
            <a dropdownToggle>
              <div class="user-info" [class.top-10]="!currentUser?.businessEntity?.shortName">
                {{currentUser?.firstName | titlecase}} {{currentUser?.lastName | titlecase}}
                <span>{{currentUser?.businessEntity?.shortName || currentUser?.businessEntity?.name}}</span>
              </div>

              <div class="user-photo-wrapper text-align-center">
                <ng-container *ngTemplateOutlet="photoTemplate; context: { $implicit: currentUser?.photo }"></ng-container>
              </div>
              <i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i>
            </a>
            <div *dropdownMenu class="dropdown-menu dropdown-menu-right dropdown-menu--block" role="menu">
              <ng-container >
                <div class="row ml-2 mt-3">
                  <div class="col-md-12">
                    <label class="text-style font-weight-bold word-break-all" style="font-size: 20px !important"> {{ currentUser?.username }} </label>
                  </div>
                </div>
                <div class="row ml-2 mt-3 hover" *ngIf="!oldUser && !isImpersonalization && !isSubstitution" (click)="loadPossibleImpersonalizations()">
                  <div class="col-md-12">
                    <label class="text-style font-weight-mid word-break-all hover"> {{ 'header.label.impersonalize-profile' | translate }} </label>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngTemplateOutlet="originUser"></ng-container>

              <hr class="separator ml-4 mr-4">
              <div class="row mt-3 ml-2" *ngIf="!isImpersonalization && !isSubstitution" (click)="editUserRedirect()">
                <div class="col-md-12">
                  <label class="text-style font-weight-mid hover"> {{ 'header.label.edit-data' | translate }}</label>
                </div>
              </div>
              <div class="row mb-2 ml-2" (click)="logout()">
                <div class="col-md-12">
                  <label class="text-style font-weight-mid hover"> {{ 'header.label.log-out' | translate }} </label>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Cannot Impersonificate View -->

          <ng-container *ngIf="!currentUser?.canImpersonificate && !isImpersonalization">

            <!-- Is Impersonalized View -->

            <a dropdownToggle *ngIf="!isImpersonalization" (click)="getSubstitutes()">
              <div class="user-info" [class.top-10]="!currentUser?.businessEntity?.shortName">
                {{(currentUser?.firstName || currentUser?.firstName )| titlecase}} {{(currentUser?.lastName || currentUser?.lastName) | titlecase}}
                <span>{{currentUser?.businessEntity?.shortName || currentUser?.businessEntity?.shortName || currentUser?.businessEntity?.shortName || currentUser?.businessEntity?.shortName}}</span>
              </div>

              <div class="user-photo-wrapper text-align-center">
                <ng-container *ngTemplateOutlet="photoTemplate; context: { $implicit: currentUser?.photo }"></ng-container>
              </div>
              <i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i>
            </a>

            <!-- Is Not Impersonalized View -->

            <a dropdownToggle *ngIf="isImpersonalization" >
                <div class="user-info" [class.top-10]="!currentUser?.businessEntity?.shortName">
                  {{currentUser?.firstName | titlecase}} {{currentUser?.lastName  | titlecase}}
                  <span>{{currentUser?.businessEntity?.shortName }}</span>
                </div>

                <!-- Has Origin User -->
                <ng-container *ngTemplateOutlet="originUser"></ng-container>

                <div class="user-photo-wrapper text-align-center">
                  <ng-container *ngTemplateOutlet="photoTemplate; context: { $implicit: currentUser?.photo }"></ng-container>
                </div>
                <i class="zmdi zmdi-chevron-down zmdi-hc-2x"></i>
            </a>

            <!---------------------------------------->

            <div *dropdownMenu class="dropdown-menu dropdown-menu-right dropdown-menu--block" role="menu">
              <!-- <div [class.visible]="isLoading" [class.invisible]="!isLoading"  class="loading">
                  <div class="loader loader-sm loader-search" ></div>
              </div>
              <div [class.visible]="!isLoading" [class.invisible]="isLoading"> -->

                <!-- Has not Substitutes -->

                <ng-container *ngIf="!substitutes || isSubstitution || isImpersonalization">
                  <div class="row ml-2 mt-3" >
                    <div class="col-md-12">
                      <label class="text-style font-weight-bold word-break-all" style="font-size: 20px !important"> {{ currentUser?.username || currentUser?.username}} </label>
                    </div>
                  </div>
                </ng-container>

                <!-- Has Origin User -->
                <ng-container *ngTemplateOutlet="originUser"></ng-container>

                <!-- Has Substitutes -->
                <ng-container *ngIf="substitutes && !isImpersonalization && !isSubstitution">
                    <div class="row mt-4 ml-2 mb-2">
                      <div class="col-md-12">
                        <label class="grey-text font-weight-mid"> {{ 'header.label.access-how-substitute-of' | translate }} </label>
                      </div>
                    </div>
                  <div class="row mb-2 hover" (click)="loadSubstitute(i)" *ngFor="let substitute of substitutes; let i = index">
                    <div class="col-md-2 ml-4">
                      <img class="photo-img hover" style="width: 25px; height: 25px;" [src]="substitute?.photo.preview | safeHtml" *ngIf="substitute?.photo?.preview; else noPreview">
                      <ng-template #noPreview>
                        <img class="img-fluid hover photo-img user-cookie-disabled" src="assets/images/user-cookie-36.svg">
                      </ng-template>
                    </div>
                    <div class="col-md-9" style="margin-left: -20px">
                      <label class="text-style font-weight-mid hover">{{ substitute?.firstName }} {{ substitute?.lastName }}</label>
                    </div>
                  </div>
                </ng-container>
              <!-- </div> -->

              <!-- Other Options -->

              <hr class="separator ml-4 mr-4">
              <div class="row mt-3 ml-2" *ngIf="!isImpersonalization && !isSubstitution" (click)="editUserRedirect()">
                <div class="col-md-12">
                  <label class="text-style font-weight-mid hover"> {{ 'header.label.edit-data' | translate }}</label>
                </div>
              </div>
              <div class="row mb-2 ml-2" (click)="logout()">
                <div class="col-md-12">
                  <label class="text-style font-weight-mid hover"> {{ 'header.label.log-out' | translate }} </label>
                </div>
              </div>
            </div>
          </ng-container>

        </li>
      </ul>
      <div class="header-tabs">
        <app-header-tabs #tabs></app-header-tabs>
      </div>
    </header>
  </div>
</div>

<div class="d-block d-sm-none header-mobile">
  <li dropdown style="list-style-type:none;">
    <a dropdownToggle>
      <div style="float: right; margin-top: 8px;">
        <ng-container *ngTemplateOutlet="photoTemplate; context: { $implicit: currentUser?.photo }"></ng-container>
      </div>
    </a>
    <div *dropdownMenu class="dropdown-menu dropdown-menu-right " role="menu" style="margin-top: 50px;">
      <div class="row ml-2" (click)="logout()">
        <div class="col-md-12">
          <label class="text-style font-weight-mid hover"> {{ 'header.label.log-out' | translate }} </label>
        </div>
      </div>
    </div>
  </li>
</div>

<ng-template #photoTemplate let-file>
    <img class="user-photo rounded-circle" [src]="file.preview | safeHtml" *ngIf="file && file.preview; else noPreview">
    <ng-template #noPreview>
      <img src="./assets/images/user-cookie-36.svg">
    </ng-template>
</ng-template>￼




<ng-template #originUser>
  <ng-container *ngIf="oldToken">
    <div class="row mt-4 ml-2 mb-2">
      <div class="col-md-12">
        <label class="grey-text font-weight-mid"> {{ 'generic.backToOriginUser.label' | translate }} </label>
      </div>
    </div>
    <div class="row mb-2 hover" (click)="changeToOldUser()">
      <div class="col-md-2 ml-4">
        <img class="photo-img hover" style="width: 25px; height: 25px;" [src]="oldUser?.photo?.preview | safeHtml" *ngIf="oldUser?.photo?.preview; else noPreview">
        <ng-template #noPreview>
          <img class="img-fluid hover photo-img user-cookie-disabled" src="assets/images/user-cookie-36.svg">
        </ng-template>
      </div>
      <div class="col-md-9" style="margin-left: -20px">
        <label class="text-style font-weight-mid hover">{{ oldUser?.firstName }} {{ oldUser?.lastName }}</label>
      </div>
    </div>
  </ng-container>
</ng-template>
